import { gql } from "@apollo/client";

export const MARK_WELCOME_MESSAGE_SEEN_MUTATION = gql`
    mutation MarkWelcomeMessageSeen {
        markWelcomeMessageSeen {
            success
        }
    }
`;

export const REDEEM_FREE_RUNESTONE_MUTATION = gql`
    mutation RedeemFreeRunestone($streamTeamMemberId: ID!) {
        redeemFreeRunestone(streamTeamMemberId: $streamTeamMemberId) {
            success
            message
            availableClaimsAfter
        }
    }
`;
